export default "__VITE_ASSET__1cd4977c__"